// extracted by mini-css-extract-plugin
export default {"label":"TimefieldComponent_label__CdgLd"};